<template>
  <div class="basic-info center">

    <tx-bg src="oldclassic_m_roleinfo_img_jn_db" class="overflow-y"  v-for="(group, g_index) in role_skills"  :key="g_index"
    :class="{'mt-32':g_index > 0}"
    >
      <div class="skill-item-title">
        <tx-bg src="oldclassic_m_roleinfo_img_biaoti" class="btn_yeqian">
          {{ group['name'] }}
        </tx-bg>
        <span class="btn_yeqian c-golden"> {{ group['level'] }}级</span>
      </div>

      <div class="skill-item-title2 c-gray">
        <span>技能名称</span>
        <span>境界</span>
      </div>
      
      <div class="skill-item-body">
        <div class="wrapper">
          <div v-for="(skill, s_index) in group['skills']" :key="s_index" class="skill-item-content">
            <mCommonItem
              :class="{ disa: !skill['lv'] }"
              :content="`#c00c0ff${skill['name']}#r${skill['intro']}`"
              :src="skill_img(skill['id'])"
            />
            <tx-bg src="oldclassic_m_roleinfo_img_jnms_db" class="rowWraper">
              <span class="sTitle">{{ skill['name'] }}</span>
              <span class="sLev">{{ skill.lv || '' }}</span>
            </tx-bg>
          </div>
        </div>
      </div>
    </tx-bg>
  </div>
</template>

<script setup>
const { skill_img } = inject('filters');

const props = defineProps({
  role_data: {
    type: Object,
    default: () => ({}),
  },
});

// 计算属性
const role_skills = computed(() => {
  return props.role_data?.role_skills || {};
});
</script>
